import React from 'react';

const Loader = () => (
  <div className="loader">
    <div className="dot" />
    <div className="dot" />
    <div className="dot" />
  </div>
);

export default Loader;
